import { Box, Typography } from '@mui/material';
import moment from 'moment';
import React from 'react';
import { classes } from '../utils';
import ROLES from '../../../../constants/roles';
import CustomTooltip from '../../utils/CustomTooltip';

const FirstName = (params) => {
  if (params?.data) {
    if (params?.data?.firstName) {
      return (
        <Typography variant="body1" fontWeight={400}>
          {params?.data?.firstName}
        </Typography>
      );
    }
    return (
      <Typography variant="body1" fontWeight={400}>
        -
      </Typography>
    );
  }
};
const LastName = (params) => {
  if (params?.data) {
    if (params?.data?.lastName) {
      return (
        <Typography variant="body1" fontWeight={400}>
          {params?.data?.lastName}
        </Typography>
      );
    }
    return (
      <Typography variant="body1" fontWeight={400}>
        -
      </Typography>
    );
  }
};
const OrginzationName = (params) => {
  if (params?.data) {
    if (
      params?.data?.organizationDetails &&
      params?.data?.organizationDetails?.organizationName
    ) {
      return (
        <Typography variant="body1" fontWeight={400}>
          {params?.data?.organizationDetails?.organizationName}
        </Typography>
      );
    }
    return (
      <Typography variant="body1" fontWeight={400}>
        -
      </Typography>
    );
  }
};
const EventType = (params) => {
  if (params?.data) {
    if (params?.data?.eventType) {
      const displayEvent =
        params?.data?.eventType.length > 20
          ? `${params?.data?.eventType.slice(0, 20)}.....`
          : params?.data?.eventType;
      return (
        <CustomTooltip title={`${params?.data?.eventType}`}>
          <Typography variant="body1" fontWeight={400}>
            {displayEvent}
          </Typography>
        </CustomTooltip>
      );
    }
    return (
      <Typography variant="body1" fontWeight={400}>
        -
      </Typography>
    );
  }
};
const Messages = (params) => {
  const { data } = params;
  if (data) {
    const { message } = data;
    if (typeof message !== 'object' && message) {
      const displayMessage =
        message.length > 30 ? `${message.slice(0, 30)}.....` : message;
      return (
        <CustomTooltip title={`${message}`}>
          <Typography variant="body1" fontWeight={400}>
            {displayMessage}
          </Typography>
        </CustomTooltip>
      );
    }
    return (
      <Typography variant="body1" fontWeight={400}>
        -
      </Typography>
    );
  }
};
const UserRole = (params) => {
  const getRoleLabel = (userRole) => {
    if (userRole === ROLES.ADMIN) {
      return 'Admin';
    }
    if (userRole === ROLES.MANAGER) {
      return 'Manager';
    }
    return 'Member';
  };
  if (params?.data) {
    if (params?.data?.role) {
      return (
        <Typography variant="body1" fontWeight={400}>
          {getRoleLabel(params?.data?.role)}
        </Typography>
      );
    }
    return (
      <Typography variant="body1" fontWeight={400}>
        -
      </Typography>
    );
  }
};
const date = (params) => {
  const { value } = params;
  const formattedDate =
    value && moment.utc(value).local().format('DD-MM-YYYY HH:mm:ss');

  if (params?.data) {
    return (
      <Box>
        {value !== undefined && value !== null ? (
          <Typography variant="body1" fontWeight="400">
            {formattedDate}
          </Typography>
        ) : (
          <Box className={classes.dateValueBox}>
            <Typography>-</Typography>
          </Box>
        )}
      </Box>
    );
  }
};

const activityHistoryColumnDef = (
  gridSettingData,
  gridKey,
  // setCustomFilterValue,
  customFilterValue,
  screenWidth,
) => {
  const isSmallScreen = screenWidth < 600;

  return [
    {
      headerName: 'FirstName',
      field: 'firstName',
      headerComponent: 'ResponsiveSortingHeader',
      headerComponentParams: {
        gridSettingData,
        gridKey,
      },
      sortable: true,
      minWidth: isSmallScreen ? 100 : 125,
      maxWidth: isSmallScreen ? 120 : 150,
      resizable: false,
      cellRenderer: FirstName,
      pinned: isSmallScreen ? '' : 'left',
      lockPinned: true,
      lockPosition: true,
      filter: true,
      suppressMenu: true,
      type: 'text',
      filterParams: {
        filterOptions: ['contains'],
        buttons: ['reset', 'apply'],
        suppressAndOrCondition: true,
        closeOnApply: true,
      },
      hide: false,
    },
    {
      headerName: 'LastName',
      field: 'lastName',
      headerComponent: 'ResponsiveSortingHeader',
      headerComponentParams: {
        gridSettingData,
        gridKey,
      },
      sortable: true,
      minWidth: isSmallScreen ? 100 : 125,
      maxWidth: isSmallScreen ? 120 : 150,
      resizable: false,
      cellRenderer: LastName,
      pinned: isSmallScreen ? '' : 'left',
      lockPinned: true,
      lockPosition: true,
      type: 'text',
      filter: true,
      suppressMenu: true,
      filterParams: {
        filterOptions: ['contains'],
        buttons: ['reset', 'apply'],
        suppressAndOrCondition: true,
        closeOnApply: true,
      },
      hide: false,
    },
    {
      headerName: 'Orginization Name',
      field: 'organizationName',
      headerComponent: 'ResponsiveSortingHeader',
      headerComponentParams: {
        gridSettingData,
        gridKey,
      },
      sortable: true,
      maxWidth: isSmallScreen ? 200 : 300,
      minWidth: isSmallScreen ? 150 : 250,
      filter: true,
      suppressMenu: true,
      type: 'text',
      cellRenderer: OrginzationName,
      filterParams: {
        filterOptions: ['contains'],
        buttons: ['reset', 'apply'],
        suppressAndOrCondition: true,
        closeOnApply: true,
      },
    },
    {
      headerName: 'EventType',
      field: 'eventType',
      headerComponent: 'ResponsiveSortingHeader',
      type: 'text',
      headerComponentParams: {
        gridSettingData,
        gridKey,
      },
      sortable: true,
      minWidth: isSmallScreen ? 80 : 125,
      maxWidth: isSmallScreen ? 120 : 200,
      filter: true,
      suppressMenu: true,
      cellRenderer: EventType,
      filterParams: {
        filterOptions: ['contains'],
        buttons: ['reset', 'apply'],
        suppressAndOrCondition: true,
        closeOnApply: true,
      },
    },
    {
      headerName: 'Messages',
      field: 'message',
      type: 'text',
      headerComponent: 'ResponsiveSortingHeader',
      headerComponentParams: {
        gridSettingData,
        gridKey,
      },
      sortable: true,
      maxWidth: isSmallScreen ? 200 : 300,
      minWidth: isSmallScreen ? 150 : 300,
      filter: true,
      suppressMenu: true,
      cellRenderer: Messages,
      filterParams: {
        filterOptions: ['contains'],
        buttons: ['reset', 'apply'],
        suppressAndOrCondition: true,
        closeOnApply: true,
      },
    },
    {
      headerName: 'Role',
      field: 'role',
      type: 'checkBox',
      headerComponent: 'ResponsiveSortingHeader',
      headerComponentParams: {
        gridSettingData,
        gridKey,
        customFilterValue,
      },
      // filter: 'CustomDropdownFilter',
      cellRenderer: UserRole,
      minWidth: isSmallScreen ? 80 : 120,
      maxWidth: isSmallScreen ? 150 : 220,
      sortable: true,
      // filterParams: {
      //   setCustomFilterValue,
      //   customFilterValue,
      //   gridKey,
      // },
    },
    {
      headerName: 'Timestamp',
      field: 'timestamp',
      headerComponent: 'ResponsiveSortingHeader',
      headerComponentParams: {
        gridSettingData,
        gridKey,
      },
      sortable: true,
      minWidth: isSmallScreen ? 100 : 150,
      maxWidth: isSmallScreen ? 200 : 250,
      cellRenderer: date,
      filter: 'agDateColumnFilter',
      type: 'date',
      suppressMenu: true, // Hides the filter icon
      filterParams: {
        filterOptions: ['inRange'],
        buttons: ['reset', 'apply'],
        suppressAndOrCondition: true,
        closeOnApply: true,
        // minValidDate: superAdminOrSuperManager ? null : formattedMinDate,
        // maxValidDate: todayString,
        comparator: (filterDate, cellValue) => {
          const cellDate = new Date(cellValue);
          if (cellDate < filterDate) return -1;
          if (cellDate > filterDate) return 1;
          return 0;
        },
      },
    },
  ];
};

export default activityHistoryColumnDef;
